import { publicUrlFor } from "../../../../globals/constants"
import FastImage from "../../../../globals/elements/fastimg"
export default function Service4({
    options,
    data 
}) {
    return (
        <div className="section-full bg-change-section overlay-wraper p-t80 p-b50">
            <div className="overlay-main bg-secondry opacity-09" />
            <div className="bg-changer">
                <div className=" section-bg active" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg1.jpg")})` }} />
                <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg2.jpg")})` }} />
                <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg3.jpg")})` }} />
                <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg4.jpg")})` }} />
                <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg5.jpg")})` }} />
                <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg6.jpg")})` }} />
            </div>
            <div className="container">
                {/* TITLE START*/}
                <div className="section-head text-center text-white">
                    <h2 data-title="Choose us">{options.title} </h2>
                    <div className="mt-separator-outer">
                        <div className="mt-separator site-bg-primary" />
                    </div>
                </div>
                {/* TITLE END*/}
                <div className="section-content">
                    <div className="row">
                        {
                            data && data.length > 0 && data.map((item,index) => {
                                return (
                                    <div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={`item-${index}`}>
                                        <div className="mt-icon-box-wraper  p-a30 bgcall-block hover-shadow hover-border-outer hover-border m-b30">
                                            <div className="icon-md radius m-b15">
                                                <span className="icon-cell  text-white">
                                                    <FastImage src={item?.img.url} />
                                                </span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte  m-b15 site-text-primary">{item?.title}</h4>
                                                <p className="text-white">{item?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                        
                    </div>
                </div>
            </div>
        </div>
    )
}